import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import AdminLayout from "pages/AdminLayout/AdminLayout";
import Forbidden from "pages/Forbidden";
import Login from "pages/Login";
import Dashboard from "pages/Dashboard";

import ProtectedRoute from "./ProtectedRoute";

const SaleServices = lazy(() => import("pages/Sales/Services"));
const Customers = lazy(() => import("pages/Catalogs/Customers"));
const Products = lazy(() => import("pages/Catalogs/Items"));
const Providers = lazy(() => import("pages/Catalogs/Providers"));
const AppointmentsModule = lazy(() => import("pages/Schedule/Appointments"));

export default function AppRoutes() {
    return (
        <Suspense>
            <Routes>
                <Route path="/" element={<AdminLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="sales">
                        <Route element={<ProtectedRoute permission='sales.orders.view' />}>
                            <Route path="service" element={<SaleServices />} />
                        </Route>
                    </Route>
                    <Route path="schedule">
                        <Route element={<ProtectedRoute permission='schedule.appointments.view' />}>
                            <Route path="appointments" element={<AppointmentsModule />} />
                        </Route>
                    </Route>
                    <Route path="catalogs">
                        <Route element={<ProtectedRoute permission='catalogs.customers.view' />}>
                            <Route path="customers" element={<Customers />} />
                        </Route>
                        <Route element={<ProtectedRoute permission='catalogs.items.view' />}>
                            <Route path="products" element={<Products />} />
                        </Route>
                        <Route element={<ProtectedRoute permission='catalogs.providers.view' />}>
                            <Route path="providers" element={<Providers />} />
                        </Route>
                    </Route>
                </Route>

                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Forbidden />} />
            </Routes>
        </Suspense>
    )
}